export const data = {
    datasets: [{
        label: '계약금액',
        stack: 'contract'
    }, {
        label: '목표금액',
        stack: 'goal'
    }],
};

export const options = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                label: (tooltipItems) => {
                    return tooltipItems.formattedValue + "원";
                },
            }
        },
        datalabels: {
            formatter: function (value, context) {
                return `${(value / 100000000).toFixed(2) + " 억원"}`;
            }
        }
    },
    
    onHover: (event, chartElement) => {
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    }
}
